import backgroundColors from '../constants/colors';
import { getAppropriateColor } from '../helpers';

// Create "song" component saying Godnat when all songs are done.
const songDefaultBackgroundColor = backgroundColors[backgroundColors.length - 1];
const songDefaultColor = getAppropriateColor(songDefaultBackgroundColor);
const Backdrop = () => (
  <div
    className="song"
    style={{
      backgroundColor: songDefaultBackgroundColor,
      color: songDefaultColor,
      textAlign: 'center',
    }}
  >
    <h1 className="song__title">Godnat</h1>
  </div>
);

export default Backdrop;



// WEBPACK FOOTER //
// ./components/backdrop.js